/* tslint:disable */
import { HitConclusion } from "./HitConclusion"
import { ErrorMessage } from "./ErrorMessage"

export class ExecutionResult {
		DecisionId: number;
		DecisionTableId: number;
		DecisionServiceId: number;
		Reference: string;
		ConclusionValueType: string;
		ViewModelFinalConclusionBusinessDataIds: string;

		HitConclusions: HitConclusion[];
		Errors: ErrorMessage[];
}



// WEBPACK FOOTER //
// D:/a/1/s/src/services/generated/models/ExecutionResult.ts